import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import { Link, useLocation } from "react-router-dom";

export default function CustomButtonsRedirectShips() {
    const { t } = useTranslation();
    const location = useLocation();

    // Ruta actual, por ejemplo: '/DetailsNaves/'
    const currentPath = location.pathname;

    return (
        <div>
            <div className="container-fluid mt-4">
                <div className="col-sm-12 col-md-12 col-lg-11 mx-auto">
                    <ButtonGroup>
                        <Link to="/DetailsNaves/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/DetailsNaves/'}
                            >
                                {t("Global_Label_Text_Details")}
                            </Button>
                        </Link>
                        <Link to="/InformationNaves/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/InformationNaves/'}
                            >
                                {t("Global_Label_Text_Information")}
                            </Button>
                        </Link>
                        <Link to="/SilosNaves/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/SilosNaves/'}
                            >
                                {t("Global_Label_Text_Silos")}
                            </Button>
                        </Link>
                        <Link to="/AlternationNaves/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/AlternationNaves/'}
                            >
                                {t("Global_Label_Text_Alternation")}
                            </Button>
                        </Link>
                    </ButtonGroup>
                </div>
            </div>
        </div>
    );
}